module.exports = __webpack_public_path__ + "static/media/cu.29f55fa7.svg";